import { Paper, Stack, Typography } from "@mui/material";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { useT } from "../../Translation/hooks/useT";
import { useProjectContext } from "../hooks/useProjectContext";
import { ProjectScorecardForm } from "./ProjectScorecardForm";

export const ProjectScorecardPage = () => {
  const { project } = useProjectContext();
  const t = useT();

  if (!project) return null;

  return (
    <FullHeightContainer maxWidth="md">
      <Stack py={5} spacing={3}>
        <Typography variant="h3">
          {t("ProjectScorecardPage_Heading_Questions")}
        </Typography>
        <Paper variant="outlined">
          <ProjectScorecardForm project={project} />
        </Paper>
      </Stack>
    </FullHeightContainer>
  );
};
